import { render, staticRenderFns } from "./informationAction.vue?vue&type=template&id=28d85ddd&"
import script from "./informationAction.vue?vue&type=script&lang=js&"
export * from "./informationAction.vue?vue&type=script&lang=js&"
import style0 from "./informationAction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports